<template>
    <!-- ---------------------------------- 企业资讯 ---------------------------------- -->
    <div class="information">
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Header></Header>
        <!-- ---------------------------------- 企业资讯 ---------------------------------- -->
        <div class="content" v-if="tableIndex === 0">
            <!-- 标题 -->
            <h2>企业资讯</h2>
            <!-- 横线 -->
            <div class="line"></div>
            <!-- 资讯 -->
            <div class="news" v-for="(item, index) in year2">
                <!-- 年份 -->
                <p class="year">{{ item }}</p>
                <!-- 内容 -->
                <div class="news_main">
                    <!-- 十月25 -->
                    <div
                        class="news_box"
                        v-for="(item2, index) in nr2"
                        v-if="item2.backup1 === item"
                    >
                        <!-- 月份 -->
                        <div class="mouth">
                            <h6>{{ item2.createTime.substring(8) }}</h6>
                            <p>{{ item2.backup2 }}</p>
                        </div>
                        <!-- 文章内容 -->

                        <div class="article">
                            {{ item2.title.substring(0, 36) }}
                        </div>
                        <div>
                            <!-- 插图 -->
                            <img
                                v-lazy="
                                    'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                    item2.cover
                                "
                                alt=""
                            />
                            <!-- 继续阅读 -->
                            <p class="go_on" @click="toInforMain(item2.id)">
                                继续阅读 >
                            </p>
                        </div>
                    </div>
                </div>
                <!-- 虚线 -->
                <div
                    v-if="index < Number(year2.length) - 1"
                    class="dotted_line"
                ></div>
            </div>
            <!-- 箭头-下 -->
            <img
                class="arrow"
                v-if="nr.length > 8"
                src="../assets/images/icon/arrow-under.png"
                alt=""
                @click="quanbu()"
            />
        </div>

        <div class="content" v-else-if="tableIndex === 1">
            <!-- 标题 -->
            <h2>企业资讯</h2>
            <!-- 横线 -->
            <div class="line"></div>
            <!-- 资讯 -->
            <div class="news" v-for="(item1, index) in year">
                <!-- 年份 -->
                <p class="year">{{ item1 }}</p>
                <!-- 内容 -->
                <div class="news_main">
                    <!-- 十月25 -->
                    <div
                        class="news_box"
                        v-for="(item3, index) in nr"
                        v-if="item3.backup1 === item1"
                    >
                        <!-- 月份 -->
                        <div class="mouth">
                            <h6>{{ item3.createTime.substring(8) }}</h6>
                            <p>{{ item3.backup2 }}</p>
                        </div>
                        <!-- 文章内容 -->
                        <div class="article" id="arti">
                            {{ item3.title.substring(0, 36) }}
                        </div>
                        <!-- 插图 -->
                        <img
                            :src="
                                'http://118.89.87.102:8080/jeecg-boot/sys/common/static/' +
                                item3.cover
                            "
                            alt=""
                            style="width: 100%; height: 123px"
                        />
                        <!-- 继续阅读 -->
                        <p class="go_on" @click="toInforMain(item3.id)">
                            继续阅读 >
                        </p>
                    </div>
                </div>
                <!-- 虚线 -->
                <div
                    v-if="index < Number(year.length) - 1"
                    class="dotted_line"
                ></div>
            </div>
        </div>
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Axios from 'axios';
export default {
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            year: [],
            year2: [],
            nr2: [],
            nr: [],
            tableIndex: 0,
        };
    },
    created() {
        this.getInformation();
    },
    methods: {
        //显示全部
        quanbu() {
            var that = this;
            that.tableIndex = 1;
        },
        // 跳转企业资讯详情
        toInforMain(id) {
            this.$router.push({
                path: '/information_main?id=' + id,
            });
        },
        getInformation() {
            var that = this;
            var years = [];
            var oneList = [];
            var twoList = [];
            var url =
                'http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/informationQueryList';
            Axios.get(url).then((res) => {
                if (res.data.success === true) {
                    for (let i = 0; i < res.data.result.length; i++) {
                        that.nr.push(res.data.result[i]);
                        years.push(res.data.result[i].backup1);
                    }
                    var set = new Set(years);
                    that.year = Array.from(set).sort(function (a, b) {
                        return b - a;
                    });
                    for (let j = 0; j < 2; j++) {
                        for (let i = 0; i < that.nr.length; i++) {
                            if (that.nr[i].backup1 === that.year[j]) {
                                if (
                                    (j === 0 && oneList.length === 6) ||
                                    (j === 1 && twoList.length === 3) ||
                                    (j === 1 && oneList.length > 3)
                                ) {
                                    break;
                                }
                                if (j === 0) {
                                    oneList.push(that.nr[i]);
                                } else if (j === 1) {
                                    twoList.push(that.nr[i]);
                                }
                            }
                        }
                    }
                    for (let i = 0; i < oneList.length; i++) {
                        that.year2 = that.year.slice(0, 1);
                        that.nr2.push(oneList[i]);
                    }
                    if (oneList.length <= 3) {
                        for (let i = 0; i < twoList.length; i++) {
                            that.year2 = that.year.slice(0, 2);
                            that.nr2.push(twoList[i]);
                        }
                    }
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
// ---------------------------- 内容 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .content {
        // 标题
        h2 {
            font-size: 60px;
        }
        // 横线
        .line {
            width: 424px;
        }
        // 年份2020
        .year {
            font-size: 74px;
        }
        // 内容
        .news_box {
            width: 42%;
            // 月份
            .mouth {
                width: 160px;
                height: 160px;
                h6 {
                    font-size: 54px;
                    margin-bottom: -8px !important;
                }
            }
            // 文章内容
            .article {
                font-size: 46px;
                height: 1rem !important;
            }
            // 文章插图
            img {
                width: 83%;
                height: 300px !important;
            }
            // 继续阅读
            .go_on {
                font-size: 50px;
                padding-bottom: 50px;
            }
            .mouth {
                p {
                    font-size: 40px !important;
                }
            }
        }
    }
    #arti {
        height: 100px;
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .content {
        // 标题
        h2 {
            font-size: 50px;
            font-weight: lighter;
        }
        // 横线
        .line {
            width: 344px;
        }
        // 年份2020
        .year {
            font-size: 44px;
        }
        // 内容
        .news_box {
            width: 26%;
            // 月份
            .mouth {
                width: 160px;
                height: 160px;
                h6 {
                    font-size: 40px;
                    margin-top: 10% !important;
                    margin-bottom: -8px !important;
                }
            }
            // 文章内容
            .article {
                font-size: 22px;
            }
            // 文章插图
            img {
                width: 80%;
                height: 200px;
            }
            // 继续阅读
            .go_on {
                font-size: 20px;
            }
        }
    }
}
.content {
    width: 100%;
    background-color: #ecf3cf;
    padding: 86px 0 90px 0;
    // 标题
    h2 {
        color: #a8ae00;
        letter-spacing: 15px;
        text-align: center;
        margin-bottom: 29px;
    }
    // 横线
    .line {
        border-bottom: 8px solid #a8ae00;
        margin: 0 auto;
        margin-bottom: 61px;
    }
    // 资讯
    .news {
        width: 76%;
        margin: 0 auto;
        // 年份2020
        .year {
            color: #a8ae00;
            margin: 0;
            font-weight: bold;
            margin-bottom: 82px;
        }
        // 内容
        .news_main {
            width: 100%;
            display: flex;
            // justify-content: space-between;
            box-sizing: border-box;
            padding-left: 7%;
            flex-wrap: wrap;
            .news_box {
                background-color: white;
                margin-top: 57px;
                margin-right: 7%;
                // 月份
                .mouth {
                    background-color: #a8ae00;
                    margin: -43px 0 0 -31px;
                    text-align: center;
                    color: white;
                    box-sizing: border-box;
                    padding-top: 15px;
                    h6 {
                        letter-spacing: 5px;
                        margin: 0;
                        color: white;
                    }
                    p {
                        font-size: 20px;
                        letter-spacing: 5px;
                        margin: 0;
                    }
                }
                // 文章内容
                .article {
                    color: #1b2d56;
                    line-height: 1.5;
                    letter-spacing: 1px;
                    width: 76%;
                    margin: 0 auto;
                    margin-top: 17px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;
                    overflow: hidden;
                    height: 0.55rem;
                }
                // 文章插图
                img {
                    // width: 100%;
                    // height: 152px;
                    display: block;
                    margin: 0 auto;
                    margin-top: 21px;
                }
                // 继续阅读
                .go_on {
                    width: 74%;
                    margin: 0 auto;
                    color: #1b2d56;
                    letter-spacing: 1px;
                    margin-top: 27px;
                    margin-bottom: 30px;
                    cursor: pointer;
                }
            }
        }
    }
    // 虚线
    .dotted_line {
        width: 80%;
        margin: 0 auto;
        border-bottom: 5px dashed #a8ae00;
        margin-top: 100px;
        margin-bottom: 80px;
    }
    // 箭头-下
    .arrow {
        width: 104px;
        display: block;
        margin: 0 auto;
        margin-top: 80px;
        cursor: pointer;
    }
}
img[lazy='loading'] {
    width: 10%;
    height: 50%;
    margin-left: 28%;
    margin-top: 8%;
}
</style>



// WEBPACK FOOTER //
// src/view/news.vue